import ReactGA from 'react-ga';
import { getReactEnv } from '../constants';

export const trackPageView = (path) => {
  if (getReactEnv() === 'production') {
    ReactGA.pageview(path || window.location.pathname);
  }
};

export const trackEvent = (event) => {
  if (getReactEnv() === 'production') {
    ReactGA.event(event);
  }
};
